import { render, staticRenderFns } from "./AnimalSearch.vue?vue&type=template&id=e84f87c8"
import script from "./AnimalSearch.vue?vue&type=script&lang=ts"
export * from "./AnimalSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports